import { useEffect } from "react";
import { Card, Col, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { DeleteOutlined, EditOutlined} from '@ant-design/icons';
import { deleteFormaPago } from "../../redux/actions";

function ListaFormaPagos({data}) {
    const { handleDatosCheque,
        handleDatosTarjeta,
        handleDatosTransferencia
    } = data
    const dispatch = useDispatch();

    const pagos = useSelector((state) => state.formapagoredux.pagos ) || [];

    const handleDelete = (pago) => {
        dispatch(deleteFormaPago(pago.value));
    }

    const handleEdit = (pago) => {

        const tipo = pago.datosBancario.tipo;

        const acciones = {
            "CQ": () => handleDatosCheque(),
            "TC": () => handleDatosTarjeta(),
            "TRA": () => handleDatosTransferencia(),
        };

        if (acciones[tipo]) {
            acciones[tipo]();
        }
    }

    return (
        <Card className="mt-2">
            <Card.Body className="p-2">
                <small className="fw-semibold">Pagos registrados</small>

                {pagos.length > 0 ? (
                    pagos.map((pago, index) => (
                        <Row key={index} className="mb-1">
                            <Col className="d-flex align-items-center">
                                <div className="pe-2"><DeleteOutlined title='Eliminar' style={{cursor:'pointer', color:'red'}} onClick={() => handleDelete(pago)}/></div>
                                <div className="flex-grow-1 text-start">
                                    <small className="pe-2">
                                        {pago.label} 
                                    </small>
                                    {pago.datosBancario && pago.datosBancario.tipo !== 'EF' && (<EditOutlined className="text-primary" title="Editar" style={{cursor:'pointer'}} onClick={() => handleEdit(pago)} />)}
                                </div>
                                <div className="text-end"> ${pago.montoPago.toFixed(2)}</div>
                            </Col>
                        </Row>
                    ))
                ) : (
                    <p className="text-muted"><small>No hay pagos registrados.</small></p>
                )}            

            </Card.Body>

        </Card>
    )

}

export default ListaFormaPagos;